/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Daily rolling average record from LongPath.
 * @export
 * @interface RollingAverage
 */
export interface RollingAverage {
    /**
     * 
     * @type {string}
     * @memberof RollingAverage
     */
    dailyRollingAverageId: string;
    /**
     * 
     * @type {string}
     * @memberof RollingAverage
     */
    siteId: string;
    /**
     * 
     * @type {string}
     * @memberof RollingAverage
     */
    siteName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RollingAverage
     */
    nodeName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RollingAverage
     */
    reportDateUtc: Date;
    /**
     * 
     * @type {number}
     * @memberof RollingAverage
     */
    dailyRollupAverageKghr?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RollingAverage
     */
    sevenDayRollupAverageKghr?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RollingAverage
     */
    ninetyDayRollupAverageKghr?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RollingAverage
     */
    sevenDayTrendKghr?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RollingAverage
     */
    sevenDayTrendPercent?: number | null;
}

/**
 * Check if a given object implements the RollingAverage interface.
 */
export function instanceOfRollingAverage(value: object): value is RollingAverage {
    if ((!('dailyRollingAverageId' in (value as Record<string, any>)) && !('daily_rolling_average_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['dailyRollingAverageId'] === undefined && (value as Record<string, any>)['daily_rolling_average_id'] === undefined)) return false;
    if ((!('siteId' in (value as Record<string, any>)) && !('site_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['siteId'] === undefined && (value as Record<string, any>)['site_id'] === undefined)) return false;
    if ((!('reportDateUtc' in (value as Record<string, any>)) && !('report_date_utc' in (value as Record<string, any>))) || ((value as Record<string, any>)['reportDateUtc'] === undefined && (value as Record<string, any>)['report_date_utc'] === undefined)) return false;
    return true;
}

export function RollingAverageFromJSON(json: any): RollingAverage {
    return RollingAverageFromJSONTyped(json, false);
}

export function RollingAverageFromJSONTyped(json: any, ignoreDiscriminator: boolean): RollingAverage {
    if (json == null) {
        return json;
    }
    return {
        
        'dailyRollingAverageId': json['daily_rolling_average_id'],
        'siteId': json['site_id'],
        'siteName': json['site_name'] === undefined ? undefined : json['site_name'] === null ? null : json['site_name'],
        'nodeName': json['node_name'] === undefined ? undefined : json['node_name'] === null ? null : json['node_name'],
        'reportDateUtc': (new Date(json['report_date_utc'])),
        'dailyRollupAverageKghr': json['daily_rollup_average_kghr'] === undefined ? undefined : json['daily_rollup_average_kghr'] === null ? null : json['daily_rollup_average_kghr'],
        'sevenDayRollupAverageKghr': json['seven_day_rollup_average_kghr'] === undefined ? undefined : json['seven_day_rollup_average_kghr'] === null ? null : json['seven_day_rollup_average_kghr'],
        'ninetyDayRollupAverageKghr': json['ninety_day_rollup_average_kghr'] === undefined ? undefined : json['ninety_day_rollup_average_kghr'] === null ? null : json['ninety_day_rollup_average_kghr'],
        'sevenDayTrendKghr': json['seven_day_trend_kghr'] === undefined ? undefined : json['seven_day_trend_kghr'] === null ? null : json['seven_day_trend_kghr'],
        'sevenDayTrendPercent': json['seven_day_trend_percent'] === undefined ? undefined : json['seven_day_trend_percent'] === null ? null : json['seven_day_trend_percent'],
    };
}

export function RollingAverageToJSON(json: any): RollingAverage {
    return RollingAverageToJSONTyped(json, false);
}

export function RollingAverageToJSONTyped(value?: RollingAverage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'daily_rolling_average_id': value['dailyRollingAverageId'],
        'site_id': value['siteId'],
        'site_name': value['siteName'],
        'node_name': value['nodeName'],
        'report_date_utc': value['reportDateUtc'].toISOString(),
        'daily_rollup_average_kghr': value['dailyRollupAverageKghr'],
        'seven_day_rollup_average_kghr': value['sevenDayRollupAverageKghr'],
        'ninety_day_rollup_average_kghr': value['ninetyDayRollupAverageKghr'],
        'seven_day_trend_kghr': value['sevenDayTrendKghr'],
        'seven_day_trend_percent': value['sevenDayTrendPercent'],
    };
}

